import {gql} from '@apollo/client'

export const accountConfirmMutation = gql`
  mutation AccountConfirm($email: String!, $token: String!) {
    confirmAccount(email: $email, token: $token) {
      accountErrors {
        field
        code
      }
      user {
        email
        isActive
      }
    }
  }
`

export const tokenCreateMutation = gql`
  mutation TokenCreate($email: String!, $password: String!) {
    tokenCreate(email: $email, password: $password) {
      accountErrors {
        field
        code
      }
      user {
        firstName
        lastName
        email
        isActive
      }
      token
    }
  }
`

export const meQuery = gql`
  query Me {
    me {
      id
      email
      firstName
      lastName
      isActive
    }
  }
`
